
import { motion } from "framer-motion";

export default function TechnicalSpecifications({ specifications, default1, selectedSpec, onSpecChange }) {

  const currentSelectedSpec = selectedSpec || default1;

  return (
    <div className="">
      <div className="flex space-x-4 mt-4 px-4 md:px-0 flex-wrap">
        {Object.keys(specifications).map((spec) => (
          <button
            key={spec}
            // Use the passed-in onSpecChange function
            onClick={() => onSpecChange(spec)}
            className={`px-4 py-2 mb-2 md:mb-0 ${
              // Added mb-2 for better wrapping on mobile
              currentSelectedSpec === spec
                ? "bg-[#cc673d] text-white"
                : "bg-[#e27a4d] text-white"
            }`}
          >
            {spec}
          </button>
        ))}
      </div>

      {/* Check if the selected spec exists before trying to render */}
      {specifications[currentSelectedSpec] ? (
        <motion.div
          // Use currentSelectedSpec for the key and data access
          key={currentSelectedSpec}
          initial={{ opacity: 1, y: 0 }} // Changed initial opacity to 1 for smoother transition if desired
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }} // Slightly faster transition
          className="mt-6 flex gap-6 md:flex-row-reverse flex-col w-full"
        >
          <img
            src={specifications[currentSelectedSpec].image}
            alt={currentSelectedSpec}
            className="md:w-1/2 object-contain" // Added object-contain
          />
          <div className="md:w-1/2 px-4 md:px-0">
            <h3 className="text-2xl font-semibold pb-8 pt-4">
              {currentSelectedSpec}
            </h3>
            <ul>
              {specifications[currentSelectedSpec].details.map(
                (detail, index) => (
                  <li
                    key={index}
                    className="border-b border-t border-black border-collapse py-6 grid grid-cols-2"
                  >
                    <span>{detail.label}</span> <span>{detail.value}</span>
                  </li>
                )
              )}
            </ul>
          </div>
        </motion.div>
      ) : (
        // Optional: Display a message if the spec data is missing for the selected key
        <div className="mt-6 px-4 md:px-0">
          <p>
            Specification details not available for "{currentSelectedSpec}".
          </p>
        </div>
        // .env not deploying for i doing that
      )}
    </div>
  );
}